import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'

const DocumentenGoedkeuren = ({ data }) => {

    return <>
        <Card className="main-card ">
            <CardBody>
                <Row >
                    <Col className="col-12">
                        <h5 className="mb-4">Documenten goedkeuren</h5>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">Naam</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span className='text-break'>{data?.name}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">Plaats</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span>{data?.city}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">BSN</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span className='text-break'>{data?.bsn}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">Geboortedatum</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span>{data?.birthday}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">Mobiel</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span>{data?.mobile}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">E-mail</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span>{data?.vEmail}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
                            <Col className="col-md-6 mt-0">Type</Col>
                            <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                <span>{data?.doc}</span>
                            </Col>
                        </Row>
                        {
                            data?.doc === 'VOG' &&
                            <Row className="mt-1 d-flex justify-content-between align-items-center">
                                <Col className="col-md-6 mt-0">Datum uitgifte</Col>
                                <Col className="col-md-6 mt-0 d-flex justify-content-end">
                                    <span>{data?.docDay}-{data?.docMonth}-{data?.docYear}</span>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>
}

export default DocumentenGoedkeuren;